/**
 * Zendesk widget
 *
 * The Zendesk widget has been deprecated for now, so this will simply open a new tab.
 */

/* eslint-disable */
import HfReactHelper from 'common/utils/hf-react-helper';

export function activate() {
  window.open(HfReactHelper.urlHelper('account/zendeskSSO'));
}

